import { Volume2, CircleStop } from "lucide-react";
import { useState } from "react";

const ReadAloud = ({ text, isDarkTheme }) => {
  const [isSpeaking, setIsSpeaking] = useState(false);
  const speech = new SpeechSynthesisUtterance(text);

  const handleReadAloud = () => {
    if (!isSpeaking) {
      speech.lang = "en-US"; 
      speech.rate = 1; 
      speech.pitch = 1;
      speechSynthesis.speak(speech);
      setIsSpeaking(true);
      
      speech.onend = () => setIsSpeaking(false);
    }
  };

  const handleStopReading = () => {
    speechSynthesis.cancel(); 
    setIsSpeaking(false);
  };

  return (
    <button
      onClick={isSpeaking ? handleStopReading : handleReadAloud}
      className={`relative mt-2 transition-colors 
        ${isDarkTheme ? "text-gray-500 hover:text-amber-500" : "text-gray-500/80 hover:text-amber-500"}`}
      title={isSpeaking ? "Stop Reading" : "Read Aloud"}
    >
      {isSpeaking ? (
        <CircleStop className="w-5 h-5 text-inherit" />
      ) : (
        <Volume2 className="w-5 h-5 text-inherit" />
      )}
    </button>
  );
};

export default ReadAloud;
